<template>
    <div class="flash-container alerts">
        <div class="community-alert">
            <transition-group name="flash-message" tag="div">
                <div v-for="(alert, alertIndex) in alerts" class="flash-message alert" :class="'alert-'+alert.type"
                     :key="alertIndex">{{alert.message}}
                </div>
            </transition-group>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FrontendAlerts',
        data: function () {
            return {
                alerts: []
            };
        },

        methods: {
            addAlert: function (alert) {
                this.alerts.push(alert);
                if (alert.timeout === 0) return;
                this.removeAlertAfterTimeout(alert);
            },
            removeAlertAfterTimeout: function (alert) {
                let timeout = alert.timeout || 5000;
                setTimeout(() => {
                    this.removeAlert(alert);
                }, timeout);
            },
            removeAlert: function (alert) {
                let index = this.alerts.indexOf(alert);
                this.alerts.splice(index, 1);
            }
        },
        mounted: function () {
            this.$eventHub.$on('addAlert', this.addAlert);
            this.$eventHub.$on('removeAlert', this.removeAlert);
        }
    }
</script>
